import { FETCH_OFFER_SUCCESS } from 'constants/offers';
import { FETCH_PAYMENT_SUCCESS } from 'constants/payment';

import type { Section } from 'models/section';
import { combineReducers } from 'redux';
export type OffersActionType =
  | typeof FETCH_OFFER_SUCCESS
  | typeof FETCH_PAYMENT_SUCCESS;

type OffersAction = {
  type: OffersActionType;
  payload: {
    entities: {
      sections: Record<string, Section>;
    };
  };
};

export const byId = (
  state: Record<string, Section> = {},
  action: OffersAction,
) => {
  switch (action.type) {
    case FETCH_OFFER_SUCCESS:
    case FETCH_PAYMENT_SUCCESS:
      const {
        entities: { sections = {} },
      } = action.payload;
      return sections;
    default:
      return state;
  }
};

export const ids = (state: string[] = [], action: OffersAction) => {
  switch (action.type) {
    case FETCH_OFFER_SUCCESS:
    case FETCH_PAYMENT_SUCCESS:
      const {
        entities: { sections = {} },
      } = action.payload;
      return Object.keys(sections);
    default:
      return state;
  }
};

const offers = combineReducers({ byId, ids });

export { offers };
